import * as y from 'yup'

/** @param {import("react-i18next").TFunction} t */

const validateEmails = (message) =>
  y
    .string()
    .nullable()
    .test('valid-emails', message, (value) => {
      if (!value) return true

      const emails = value
        .split(',')
        .map((email) => email.trim())
        .filter(Boolean)

      return emails.every((email) => y.string().email().isValidSync(email))
    })

export const generateSchema = (t) => {
  return {
    sendDraftInvoiceMail: y.object().shape({
      customerName: y.string().required(t('Required')),
      customerEmail: validateEmails('Email không đúng định dạng').required(
        t('Required'),
      ),
      customerEmailCc: validateEmails('Email không đúng định dạng'),

      customerEmailBcc: validateEmails('Email không đúng định dạng'),
    }),
    emailSchema: validateEmails('Email không đúng định dạng'),
  }
}
